import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import PricingLevelPaceTrendChart from './PricingLevelPaceTrendChart'
import PricingLevelRevenueOpportunity from './PricingLevelRevenueOpportunity'

export default function PricingLevelInsightsRow({
  revenueOpportunity,
  paceTrend,
}) {
  return (
    <Row className="g-3 mt-1 pricing-level-insights-row">
      <Col xl={6}>
        <Card
          body
          className="card--xs card-with-border h-100 pricing-level-insights-card"
        >
          <h2 className="h5 mb-1">Revenue Opportunity</h2>
          <p className="small text-muted mb-3">
            Sell-through by pricing level and where remaining revenue still
            exists.
          </p>
          <PricingLevelRevenueOpportunity
            revenueOpportunity={revenueOpportunity}
          />
        </Card>
      </Col>
      <Col xl={6}>
        <Card
          body
          className="card--xs card-with-border h-100 pricing-level-insights-card"
        >
          <h2 className="h5 mb-1">Pace Trend</h2>
          <p className="small text-muted mb-3">
            Event sell-through vs historical average in the run-up to show day.
          </p>
          <PricingLevelPaceTrendChart paceTrend={paceTrend} />
        </Card>
      </Col>
    </Row>
  )
}
